import React from 'react';
import PropTypes from 'prop-types';
import SectionHeader from '../SectionHeader';
import ScrollControls from '../../../../../components/ScrollControls/ScrollControls';
import ListingCard from '../../../../UserSettingsPage/components/ListingCard';
import css from './ListingsSection.module.css';

const LISTING_SKELETON_COUNT = 5;

const ListingsSection = ({
  title,
  listings,
  user = null,
  showScrollControls = false,
  scrollRef = null,
  keyPrefix = 'listing',
  loading = false,
  iconSrc = null,
  iconAlt = '',
  iconSize = 26,
}) => {
  return (
    <section className={css.section}>
      <SectionHeader
        title={title}
        user={user}
        iconSrc={iconSrc}
        iconAlt={iconAlt}
        iconSize={iconSize}
      />
      {showScrollControls && scrollRef ? (
        <div className={css.scrollControlsContainer}>
          <ScrollControls containerRef={scrollRef} theme="dark" />
        </div>
      ) : null}
      <div ref={scrollRef} className={css.listingsGrid}>
        {loading
          ? Array.from({ length: LISTING_SKELETON_COUNT }, (_, i) => (
              <div key={`${keyPrefix}-skeleton-${i}`} className={css.listingSkeleton} />
            ))
          : listings.map(listing => (
              <div
                key={`${keyPrefix}-${listing.id?.uuid || listing.id}`}
                className={css.listingItem}
              >
                <ListingCard listing={listing} />
              </div>
            ))}
      </div>
    </section>
  );
};

ListingsSection.propTypes = {
  title: PropTypes.string.isRequired,
  listings: PropTypes.arrayOf(PropTypes.object).isRequired,
  user: PropTypes.object,
  showScrollControls: PropTypes.bool,
  scrollRef: PropTypes.object,
  keyPrefix: PropTypes.string,
  loading: PropTypes.bool,
  iconSrc: PropTypes.string,
  iconAlt: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ListingsSection;
